import { z } from 'zod';
import { UseFormReturn } from 'react-hook-form';
import { QuoteFeeType } from '@trnsact/trnsact-shared-types';
import { ListingForm } from 'components/shared/TableListing/types';

import { ChargeType } from '../constants';
import { priceSchema } from '../../quote/model/schema';

export enum ChargeAttachType {
  Equipment = 'Equipment',
  Attachment = 'Attachment',
  Invoice = 'Invoice',
}

export type BasePrice = z.infer<typeof priceSchema>;

export interface Charge {
  label: string;
  type: QuoteFeeType;
  financeType: string;
  price: BasePrice;
  attachTo: {
    id: string;
    type: ChargeAttachType;
    description?: string;
  };
}

export interface ChargeListingContext {
  form: UseFormReturn<ListingForm<Charge>>;
  onRemoveRow: (index: number) => void;
}

export interface ChargesEquipmentDialogData {
  onOpenCreateChargeDialog: VoidFunction;
  onConfirm: (charges: Omit<Charge, 'attachTo'>[]) => void;
}

export interface CreateChargeDialogData {
  onConfirm: (newChargeItem: { category: ChargeType; name: string }) => void;
}
